<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button (click)="onBackClick()" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test-img="title">Service Areas</ion-title>
        <!-- @if (!vb.disabled) {
        <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
        } -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item color="secondary" class="ion-text-wrap">
        <ion-label class="ion-text-wrap" color="light">
            {{serviceAreasDefinedStr}} Ticket creation will be limited to the following zip codes:
        </ion-label>
    </ion-item>

    <ion-list class="ion-text-wrap">
        @for (area of areas; track $index) {
        <ion-item-sliding>
            <ion-item detail="true" data-test="area" href="javascript:;" (click)="onServiceAreaSingleClick(area.uid)">
                <ion-label>
                    <span class="line1">{{area.zipcode}} - {{area.city}}, {{area.regionName}}</span><br />
                    <span class="line2">{{area.distance}} miles away.</span>
                </ion-label>
            </ion-item>
            <ion-item-options>
                <ion-button color="danger" (click)="confirmDeleteArea(area)" data-test="deleteBtn">
                    <ion-icon name="trash"></ion-icon>
                    Delete
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button title="Add">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>

        <ion-fab-list side="start">
            <ion-fab-button ion-fab title="Add One" data-test="addSingleBtn" href="javascript:;"
                (click)="onServiceAreaSingleClick('')">
                <img src="assets/images/one.svg" alt="Add One">
            </ion-fab-button>

            <ion-fab-button ion-fab title="Add Multiple" data-test="addMultipleBtn" href="javascript:;"
                (click)="onServiceAreaMultipleClick()">
                <img src="assets/images/two-plus.svg" alt="Add Multiple">
            </ion-fab-button>
        </ion-fab-list>
    </ion-fab>
</ion-footer>